import React from 'react';
import {submit, isSubmitting} from 'redux-form';

import {MODALS} from 'ducks/bookings';
import {fetchCountries} from 'ducks/countries';
import Button from 'components/Button';
import {default as Modal, withModal} from 'components/Modal';

import {AddressHistoryForm} from './components';

class AddressHistoryModal extends React.Component<any> {
  componentDidMount() {
    this.props.fetchCountries();
  }

  submitForm = () => {
    this.props.submit('addressHistory');
  };

  getExtraActions = () => {
    const extraActions = this.props.getExtraActions();

    return [...this.props.closeModalExtraActions, ...extraActions];
  };

  render() {
    const {data: {form: {submitting}}, closeModal} = this.props;
    const {locationRef} = this.props.data;

    return (
      <Modal show={true} type={Modal.EXTRA_SMALL} onClose={closeModal}>
        <Modal.Header heading="Add Address" />
        <Modal.Body>
          <AddressHistoryForm
            getExtraActions={this.getExtraActions}
            locationRef={locationRef}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={this.submitForm}
            disabled={submitting}
            className="submit kyc_add_address"
            blue={!submitting}
            isLoading={submitting}>
            Add Address
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToModalData = state => {
  return {
    form: {
      submitting: isSubmitting('addressHistory')(state)
    }
  };
};

const mapDispatchToProps = {submit, fetchCountries};

export default withModal(
  MODALS.ADDRESS_HISTORY,
  mapStateToModalData,
  mapDispatchToProps
)(AddressHistoryModal);
